var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(-90 0 24)",
    fill: "url(#pattern0_402_407)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_402_407",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_402_407",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_402_407",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD3klEQVR4nO3b2YsdRRQG8JpMEsE/wDcFEREV9wVxI4gbiijuoqAoSkRJxECCaysGMaLgBKfP91UTUFxpEUWJ+OSD/4NvPrngvkTjnthS2hfmwUnmVs291d33+0E93tvn9KneanFORERERERERERERERERERERERERERERIajKIo1AG4B8CHJnwH8RPIDktc1TTOXO76ZQvJQkm+RbJZpr9Z1vT53nDOhruv1JHcfoBijFgq2Lne8gy8GgHdXUIxRe7MoirW54x4kkutIvj1GMUatVlFWWV3X8wBeiyjGqL0QXgJy5zGkYrycUIx/G4BdKkqipmnmAPjUYixplV6JIzVNM0fSVrEYoyvludy59bUYz692MZa0Z3Pn2CsAdkywGKMr5fHcefYCgCcnXYwlRXk4d76dRvKJaRVjSXsgd96dRPKRhJP6GclvEn6/OXf+nQLg/oST+VVVVcdWVXUiyW8jb11/A7gn93nohNA7E54BX3vvjx/9l/f+ZADfJRRlo5tl3vs7w4mIPIE/kDz1f/7zLJJ7YosSYnKziOTtJPdHXh0/Ajj9AP99djthFVOUfd77m90sIXlrQjH2mNmZKzjGuWEmMbYoJG90syBMsZL8K/JE7QVw/hjHuhDAb5GF/9PMrnRDRvKa2GKQ/MXMNkQc8+LYogD4A8AVbohIXhV6XWQxfvXeXxB7bACXkvw9tihmdpkbEu/9JSknhOTlqTEAuDrh6kzqEJ1iZhel3MexircMM7t22rfMTvHenxcexJFXxj4AN0wgpuvbt6iYmPaGnFwfmdk5Ka+dZnbTpGLz3t+W8g1E8gzXJ+FrOfbDjOT+sCJx0jGa2R0powRVVZ3m+qAsy1NIfp8wnnTXtGIluSmy0zTt6PIJrsvM7KSUwT2Sd087ZgD3pQxumtlxrotCb4mdk2iLcW/G2LckFOXLMPzvuqQsy2NIfpGQ1LbcOZB8LCH+T0ke5brAzI4G8HlCMg+6jgCwPeGZ8on3/sisCSwuLh7eTp/GJvGo6xiSzyTk83FZlodlC77dLBN7ZWx33V0TtjMhr/ezBN7ON8T2pKdd95ewIqEoy06eTQzJh4a8lLP4b8vcrsiibJ16wKGXRwRa9mmxc1EUa0i+FNHpdkw92LBsZhZWntd1PU/y9TFznf43FckjxphwerHPezOKolgbtseNsUgiz+svyadWEGTYETvvhrHZ9J0V5Lsz9+6mZR984U1lSPv7FhYWDjnI7euNTmzHbmcFwx7Aj9r2Su9n1w6+PmB3GKFo23thiriPz0gRERERERERERERERERERERERERERER1wf/ANTeRSHb18MHAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.72de12be6723de5bdd81b095a2d081e3.svg";
export { ForwardRef as ReactComponent };